import { orderby } from '@/helpers'

const ALLOWED_MESSAGE_TYPES = ['public', 'automatic']

const HIDE_AGENT_MESSAGE_STATUS = ['error', 'waiting']

const USER_TYPE = {
  AGENT: 1
}

const eventsTypes = {
  closed: {
    mapper(e, chat) {
      if (!(chat.leave && chat.leave.time)) {
        return {
          type: 'ConversationClosed',
          property: 'closed',
          time: chat.closed.time,
          value: e.value
        }
      }
    },
    equals(current, other) {
      return (
        current.type === other.type &&
        current.value.user &&
        other.value.user &&
        current.value.user.name === other.value.user.name
      )
    }
  },
  leave: {
    mapper(e) {
      return {
        type: 'ConversationLeave',
        property: 'leave',
        time: e.value.time,
        value: e.value
      }
    },
    equals(current, other) {
      return (
        current.type === other.type &&
        current.value.user &&
        other.value.user &&
        current.value.user.name === other.value.user.name
      )
    }
  },
  agent: {
    mapper(e) {
      return {
        type: 'ConversationAgent',
        property: 'agent',
        time: e.time,
        value: e.value
      }
    },
    equals(current, other) {
      return (
        current.type === other.type &&
        ((!current.value && !other.value) ||
          (current.value &&
            other.value &&
            current.value.name === other.value.name))
      )
    }
  },
  ticket: {
    mapper(e) {
      return {
        type: 'ConversationTicket',
        property: 'ticket',
        time: e.time,
        value: e.value
      }
    },
    equals(current, other) {
      return current.type === other.type && current.value === other.value
    }
  }
}

const createMessageEvent = (message, index) => {
  return {
    type: 'ConversationMessage',
    time: message.time,
    property: 'message',
    value: {
      key: message.key,
      index
    }
  }
}

const eventAlreadyAdded = (events, event) => {
  if (events && events.length && eventsTypes[event.property]) {
    const lastEvent = events[events.length - 1]

    return eventsTypes[event.property].equals(event, lastEvent)
  }
}

const parseMessages = (chat, messages) => {
  let events = []

  let messageEvents = chat.messages.filter(
    m =>
      ALLOWED_MESSAGE_TYPES.includes(m.type) &&
      (m.user.type !== USER_TYPE.AGENT ||
        !HIDE_AGENT_MESSAGE_STATUS.includes(m.status))
  )

  messageEvents = messageEvents.concat(
    messages.filter(m => !chat.messages.some(cm => cm.key === m.key))
  )

  events = messageEvents.map(createMessageEvent)

  return events
}

export default (chat, messages) => {
  let events = []

  if (chat) {
    events = parseMessages(chat, messages)

    if (chat.events) {
      chat.events.forEach(e => {
        if (eventsTypes[e.property]) {
          let event = eventsTypes[e.property].mapper(e, chat)

          if (event && !eventAlreadyAdded(events, event)) {
            events.push(event)
          }
        }
      })
    }
  } else {
    events = messages.map(createMessageEvent)
  }

  return orderby.asc(events, item => new Date(item.time))
}
